<template>
  <div>
    <SearchInput
      v-if="groupIndexServiceAction"
      v-model="filters.withGroupId"
      :index-service-action="groupIndexServiceAction"
      :initial-service-action="groupInitialServiceAction"
      search-scope="withName"
      :rules="[$validations.required]"
      :placeholder="$t('general.select_group')"
      :input-attrs="{ hideDetails: 'auto' }"
    />
    <v-row>
      <v-col cols="12" md="6">
        <ButtonAdd
          class="my-2"
          small
          small-font
          :text="$t('general.add_all')"
          :disabled="selectableUsers.length < 1"
          @click="addAllUsers"
        />
        <v-card class="userslist__wrapper">
          <NoResultsAlert v-if="users.length === 0" class="ma-3" />
          <v-list>
            <v-list-item
              v-for="user in selectableUsers"
              :key="user.id"
              @click="addToAssignedUsers(user)"
            >
              <v-list-item-avatar size="32" color="secondary">
                <AvatarContent :object="user" />
              </v-list-item-avatar>
              <v-list-item-content>
                <v-list-item-title>
                  {{ user.name }}
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list>
        </v-card>
      </v-col>
      <v-col cols="12" md="6">
        <v-btn
          class="my-2"
          small
          color="error"
          text
          :disabled="orderedAssignedUsers.length < 1"
          @click="removeAllUsers"
        >
          <v-icon left v-text="'mdi-minus'" />{{ $t('general.remove_all') }}
        </v-btn>

        <v-card class="userslist__wrapper">
          <v-list>
            <v-list-item
              v-for="user in orderedAssignedUsers"
              :key="user.id"
              @click="removeAssignedUser(user)"
            >
              <v-list-item-avatar size="32" color="secondary">
                <AvatarContent :object="user" />
              </v-list-item-avatar>
              <v-list-item-content>
                <v-list-item-title>
                  {{ user.name }}
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list>
        </v-card>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { findIndex, orderBy, pickBy } from 'lodash';
import AvatarContent from '@/components/AvatarContent.vue';
import SearchInput from '@/components/forms/inputs/SearchInput.vue';
import localValue from '@/mixins/localValue';
import ButtonAdd from '@/components/ButtonAdd.vue';
import NoResultsAlert from '@/components/NoResultsAlert.vue'

export default {
  mixins: [localValue],
  components: {
    AvatarContent,
    SearchInput,
    ButtonAdd,
    NoResultsAlert,
  },
  props: {
    userIndexServiceAction: {
      type: Function,
      required: true,
    },
    userInitialServiceAction: {
      type: Function,
      required: true,
    },
    groupIndexServiceAction: {
      type: Function,
      required: false,
    },
    groupInitialServiceAction: {
      type: Function,
      required: false,
    },
  },
  data() {
    return {
      assignedUsers: [],
      selectedUsers: [],
      users: [],
      filters: {
        withGroupId: '',
        blocked: '0',
      },
    };
  },
  watch: {
    assignedUsers: {
      deep: true,
      handler(val) {
        this.setUserIds(val);
      },
    },
    filters: {
      deep: true,
      immediate: true,
      handler() {
        this.getUsers();
      }
    }
  },
  computed: {
    selectableUsers() {
      return orderBy(
        this.users.filter(x => !this.assignedUserIds.includes(x.id)),
        ['name'],
        ['asc']
      );
    },
    assignedUserIds() {
      return this.assignedUsers.map(x => x.id);
    },
    orderedAssignedUsers() {
      return orderBy(this.assignedUsers, ['name', 'asc']);
    },
    appliedFilters() {
      return pickBy(this.filters, this.filterSet);
    },
  },
  methods: {
    async getUsers() {
      try {
        const { data } = await this.userIndexServiceAction(
          {
            page: {
              limit: 100
            },
            filter: this.appliedFilters
          },
        );
        this.users = data;
      } catch(e) {
        console.log(e);
      }
    },
    addToAssignedUsers(user) {
      this.assignedUsers.push(user);
    },
    removeAssignedUser(user) {
      const index = findIndex(this.assignedUsers, function(u) {
        return u.id == user.id;
      });
      this.assignedUsers.splice(index, 1);
    },
    addAllUsers() {
      this.assignedUsers = [...this.assignedUsers, ...this.selectableUsers];
    },
    removeAllUsers() {
      this.assignedUsers = [];
    },
    filterSet(filter) {
      return filter && filter !== '';
    },
    setUserIds(users) {
      this.localValue = users.map(x => x.id);
    },
  },
};
</script>

<style lang="scss" scoped>
.userslist__wrapper {
  height: 500px;
  overflow-y: auto;
  overflow-x: hidden;
  position: relative;
}
</style>
